import { useEffect } from "react";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { FeatureCards } from "../components/FeatureCards";
import { LocationSection } from "../components/LocationSection";
import { QuickFacts } from "../components/QuickFacts";
import { StatusShell } from "../components/StatusShell";
import { SubmitErrorView } from "../components/SubmitErrorView";
import { SubmittingView } from "../components/SubmittingView";
import { paths } from "../i18n/paths";
import { useI18n } from "../i18n/I18nProvider";
import { useLeadFlow } from "../lib/use-lead-flow";
import { usePageMotion } from "../lib/use-page-motion";
import { LandingSection } from "./LandingSection";

export function LandingPage() {
  const { locale } = useI18n();
  const flow = useLeadFlow(() => {
    try {
      sessionStorage.setItem("qurtuba:submitted", "1");
    } catch {
      // The flag only drives the reveal; the navigation still has to happen.
    }
    window.location.assign(paths[locale].thankYou);
  });
  usePageMotion();

  const active = flow.phase.kind !== "idle";
  const phase = flow.phase.kind;

  useEffect(() => {
    if (active) window.scrollTo(0, 0);
  }, [active, phase]);

  return (
    <>
      <div className={active ? "hidden" : "flex min-h-screen flex-col bg-white"}>
        <Header />
        <main className="flex-1">
          <LandingSection onSubmit={flow.submit} onBypass={flow.bypass} />
          <QuickFacts />
          <FeatureCards />
          <LocationSection />
        </main>
        <Footer />
      </div>

      {phase === "submitting" ? (
        <StatusShell>
          <SubmittingView />
        </StatusShell>
      ) : null}

      {flow.phase.kind === "failed" ? (
        <StatusShell>
          <SubmitErrorView
            retryUsed={flow.phase.retryUsed}
            onRetry={flow.retry}
            onEdit={flow.reset}
          />
        </StatusShell>
      ) : null}
    </>
  );
}
